// src/pages/services/Services.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import ServicesTable from "../../components/services/ServicesTable";

const Services = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ServicesTable />
        </WrapperSection>
    );
};

export default Services;
